import { motion } from 'framer-motion';
import { Smartphone, X } from 'lucide-react';
import { useState } from 'react';
import { useModal } from '../../hooks/modalContext';
import { TabbedQRSelector } from '../DownloadApp/DownloadApp';
import iosQR from '../../../assets/pages/sideNav/app_store.png';
import androidQR from '../../../assets/pages/sideNav/android_app.png';

const InAppReviewModal = () => {
  const { setModal } = useModal();
  const [activeTab, setActiveTab] = useState<'ios' | 'android'>('ios');

  return (
    <motion.div
      className='relative flex max-h-[90vh] w-full max-w-[min(92vw,640px)] flex-col overflow-hidden rounded-[12px] bg-[var(--color-dark)] shadow-xl'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className='hero shrink-0 !border-none !rounded-none'>
        <div className='pg-hero relative overflow-hidden'>
          <div className='hero-beam' aria-hidden />
          <div className='hero-orb orb-blue' aria-hidden />
          <div className='hero-orb orb-gold' aria-hidden />
          <button
            type='button'
            className='absolute right-4 top-4 z-[2] rounded-full p-1.5 text-[var(--dmuted)] transition-colors hover:bg-white/10 hover:text-white'
            aria-label='Close'
            onClick={() => setModal(null)}
          >
            <X size={22} strokeWidth={2} />
          </button>
          <div className='relative z-[1] px-[24px] py-[24px] sm:px-8 sm:pb-7'>
            <div className='hero-meta'>
              <div className='badge badge-neutral flex items-center gap-1.5 py-1 pr-2.5 pl-2'>
                <Smartphone className='h-3.5 w-3.5 shrink-0 text-[#fff] opacity-80' aria-hidden />
                <span className='font-semibold uppercase tracking-[0.1em] text-[#fff]'>
                  Mobile app only
                </span>
              </div>
            </div>
            <h2 className='hero-h1 mt-1 text-[clamp(1.25rem,3.5vw,1.6rem)]'>
              Review us in the <em>TenantPay app</em>
            </h2>
            <p className='hero-p !mb-0 max-w-[420px]'>
              This reward is available only through the mobile app. Install the app, then submit
              your feedback there to earn it.
            </p>
          </div>
        </div>
      </div>

      <div className='flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto bg-[var(--color-page)] px-5 py-6 sm:px-8'>
        <div className='mx-auto w-full max-w-[320px]'>
          <TabbedQRSelector
            appStoreUrl={iosQR}
            playStoreUrl={androidQR}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
      </div>
    </motion.div>
  );
};

export { InAppReviewModal };
